import React, { useEffect, useState } from "react";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";
import { Link } from "react-router-dom";
import { Card, Col, Nav, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { Grid } from "gridjs-react";

export default function PublisherQueue() {

  const currentSkin = (localStorage.getItem('skin-mode')) ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);

  const switchSkin = (skin) => {
    if (skin === 'dark') {
      const btnWhite = document.getElementsByClassName('btn-white');

      for (const btn of btnWhite) {
        btn.classList.add('btn-outline-primary');
        btn.classList.remove('btn-white');
      }
    } else {
      const btnOutlinePrimary = document.getElementsByClassName('btn-outline-primary');

      for (const btn of btnOutlinePrimary) {
        btn.classList.remove('btn-outline-primary');
        btn.classList.add('btn-white');
      }
    }
  };

  switchSkin(skin);

  useEffect(() => {
    switchSkin(skin);
  }, [skin]);

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">

        <div className="d-flex align-items-center justify-content-between mb-4">
          <div>
            <ol className="breadcrumb fs-sm mb-1">
              <li className="breadcrumb-item"><Link href="#">PUB Home</Link></li>
              <li className="breadcrumb-item active" aria-current="page">Queue</li>
            </ol>
          <h4 className="main-title mb-0">Queue</h4>
          </div>

          <Nav as="nav" className="nav-icon nav-icon-lg">
            <OverlayTrigger overlay={<Tooltip>Share</Tooltip>}>
              <Nav.Link href=""><i className="ri-share-line"></i></Nav.Link>
            </OverlayTrigger>
            <OverlayTrigger overlay={<Tooltip>Print</Tooltip>}>
              <Nav.Link href=""><i className="ri-printer-line"></i></Nav.Link>
            </OverlayTrigger>
            <OverlayTrigger overlay={<Tooltip>Report</Tooltip>}>
              <Nav.Link href=""><i className="ri-bar-chart-2-line"></i></Nav.Link>
            </OverlayTrigger>
            <OverlayTrigger overlay={<Tooltip>New Ad</Tooltip>}>
              <Nav.Link href="/publisher/inventory/type"><i className="ri-add-line"></i></Nav.Link>
            </OverlayTrigger>
          </Nav>

        </div>

        <Nav className="nav-line mb-4">
          <Nav.Link href="" className="active">New (30)</Nav.Link>
          <Nav.Link href="">Live (437)</Nav.Link>
          <Nav.Link href="">Placeholders (0)</Nav.Link>
          <Nav.Link href="">Rejected (42)</Nav.Link>
          <Nav.Link href="">All (509)</Nav.Link>
        </Nav>

        <Row className="g-3 justify-content-center">
  
          <Col md="12">
            <Card className="card-one">
              <Card.Body>
                <div className="table-responsive">
                  <Grid
                    data={[
                      ['1', 'NEW', 'ABC Bank', 'Top 5 Trade Finance Providers', 'TFG', 'Top List', 'Trade Finance, US', '$32.00', '$25,000.00', 'August 10, 2023 07:24'],
                      ['2', 'NEW', 'ABC Bank', 'Top 10 Trade Finance Providers', 'TFG', 'Top List', 'Trade Finance, US', '$32.00', '$25,000.00', 'August 10, 2023 07:24'],
                      ['3', 'NEW', 'ABC Bank', 'Top 10 Trade Finance Providers', 'TFG', 'Multi-Item Banner', 'Trade Finance, US', '$32.00', '$25,000.00', 'August 10, 2023 07:24'],
                      ['4', 'NEW', 'ABC Bank', 'Top 10 Trade Finance Providers', 'TFG', 'Single Banner', 'Trade Finance, US', '$32.00', '$25,000.00', 'August 10, 2023 07:24'],
                      ['5', 'NEW', 'ABC Bank', 'Top 5 Trade Finance Providers', 'TFG', 'Top List', 'Trade Finance, US', '$32.00', '$25,000.00', 'August 10, 2023 07:24'],
                      ['6', 'NEW', 'ABC Bank', 'Top 10 Trade Finance Providers', 'TFG', 'Top List', 'Trade Finance, US', '$32.00', '$25,000.00', 'August 10, 2023 07:24'],
                      ['7', 'NEW', 'ABC Bank', 'Top 10 Trade Finance Providers', 'TFG', 'Multi-Item Banner', 'Trade Finance, US', '$32.00', '$25,000.00', 'August 10, 2023 07:24'],
                      ['8', 'NEW', 'ABC Bank', 'Top 5 Trade Finance Providers', 'TFG', 'Top List', 'Trade Finance, US', '$32.00', '$25,000.00', 'August 10, 2023 07:24'],
                      ['9', 'NEW', 'ABC Bank', 'Top 10 Trade Finance Providers', 'TFG', 'Top List', 'Trade Finance, US', '$32.00', '$25,000.00', 'August 10, 2023 07:24'],
                      ['10', 'NEW', 'ABC Bank', 'Top 10 Trade Finance Providers', 'TFG', 'Multi-Item Banner', 'Trade Finance, US', '$32.00', '$25,000.00', 'August 10, 2023 07:24'],
                      ['11', 'NEW', 'ABC Bank', 'Top 10 Trade Finance Providers', 'TFG', 'Single Banner', 'Trade Finance, US', '$32.00', '$25,000.00', 'August 10, 2023 07:24'],
                      ['12', 'NEW', 'ABC Bank', 'Top 5 Trade Finance Providers', 'TFG', 'Top List', 'Trade Finance, US', '$32.00', '$25,000.00', 'August 10, 2023 07:24'],
                      ['13', 'NEW', 'ABC Bank', 'Top 10 Trade Finance Providers', 'TFG', 'Top List', 'Trade Finance, US', '$32.00', '$25,000.00', 'August 10, 2023 07:24'],
                      ['14', 'NEW', 'ABC Bank', 'Top 10 Trade Finance Providers', 'TFG', 'Multi-Item Banner', 'Trade Finance, US', '$32.00', '$25,000.00', 'August 10, 2023 07:24'],
                      ['15', 'NEW', 'ABC Bank', 'Top 10 Trade Finance Providers', 'TFG', 'Single Banner', 'Trade Finance, US', '$32.00', '$25,000.00', 'August 10, 2023 07:24'],
                      ['16', 'NEW', 'ABC Bank', 'Top 5 Trade Finance Providers', 'TFG', 'Top List', 'Trade Finance, US', '$32.00', '$25,000.00', 'August 10, 2023 07:24'],
                      ['17', 'NEW', 'ABC Bank', 'Top 10 Trade Finance Providers', 'TFG', 'Top List', 'Trade Finance, US', '$32.00', '$25,000.00', 'August 10, 2023 07:24'],
                      ['18', 'NEW', 'ABC Bank', 'Top 10 Trade Finance Providers', 'TFG', 'Multi-Item Banner', 'Trade Finance, US', '$32.00', '$25,000.00', 'August 10, 2023 07:24'],
                      ['19', 'NEW', 'ABC Bank', 'Top 10 Trade Finance Providers', 'TFG', 'Single Banner', 'Trade Finance, US', '$32.00', '$25,000.00', 'August 10, 2023 07:24'],
                      ['20', 'NEW', 'ABC Bank', 'Top 5 Trade Finance Providers', 'TFG', 'Top List', 'Trade Finance, US', '$32.00', '$25,000.00', 'August 10, 2023 07:24'],
                      ['21', 'NEW', 'ABC Bank', 'Top 10 Trade Finance Providers', 'TFG', 'Top List', 'Trade Finance, US', '$32.00', '$25,000.00', 'August 10, 2023 07:24'],
                      ['22', 'NEW', 'ABC Bank', 'Top 10 Trade Finance Providers', 'TFG', 'Multi-Item Banner', 'Trade Finance, US', '$32.00', '$25,000.00', 'August 10, 2023 07:24'],
                      ['23', 'NEW', 'ABC Bank', 'Top 5 Trade Finance Providers', 'TFG', 'Top List', 'Trade Finance, US', '$32.00', '$25,000.00', 'August 10, 2023 07:24'],
                      ['24', 'NEW', 'ABC Bank', 'Top 10 Trade Finance Providers', 'TFG', 'Top List', 'Trade Finance, US', '$32.00', '$25,000.00', 'August 10, 2023 07:24'],
                      ['25', 'NEW', 'ABC Bank', 'Top 10 Trade Finance Providers', 'TFG', 'Multi-Item Banner', 'Trade Finance, US', '$32.00', '$25,000.00', 'August 10, 2023 07:24'],
                      ['26', 'NEW', 'ABC Bank', 'Top 10 Trade Finance Providers', 'TFG', 'Single Banner', 'Trade Finance, US', '$32.00', '$25,000.00', 'August 10, 2023 07:24'],
                      ['27', 'NEW', 'ABC Bank', 'Top 5 Trade Finance Providers', 'TFG', 'Top List', 'Trade Finance, US', '$32.00', '$25,000.00', 'August 10, 2023 07:24'],
                      ['28', 'NEW', 'ABC Bank', 'Top 10 Trade Finance Providers', 'TFG', 'Top List', 'Trade Finance, US', '$32.00', '$25,000.00', 'August 10, 2023 07:24'],
                      ['29', 'NEW', 'ABC Bank', 'Top 10 Trade Finance Providers', 'TFG', 'Multi-Item Banner', 'Trade Finance, US', '$32.00', '$25,000.00', 'August 10, 2023 07:24'],
                      ['30', 'NEW', 'ABC Bank', 'Top 10 Trade Finance Providers', 'TFG', 'Single Banner', 'Trade Finance, US', '$32.00', '$25,000.00', 'August 10, 2023 07:24']
                    ]}
                    columns={['ID', 'Status', 'Advertiser', 'Inventory Name', 'Site', 'Block Type', 'Categories', 'Bid', 'Budget', 'Submitted At']}
                    search={true}
                    pagination={{
                      enabled: true,
                      limit: 15
                    }}
                    sort={true}
                    className={{
                      table: 'table table-bordered table-hover mb-0'
                    }}
                  />
                </div>
              </Card.Body>
            </Card>
          </Col>

        </Row>

        <Footer />
      </div>
    </React.Fragment>
  )
}